module.exports = __webpack_public_path__ + "static/smi4-57ae55f2968619361403a028bcdad1ad.png";